module.exports = __webpack_public_path__ + "img/marketplace.e5bdb160.png";